<template>
  <div class="fill-height">
    <v-card class="fill-height">
      <v-card-title class="p-1">
        <v-chip
            label small
            class="ma-2"
            color="secondary">
         گزارش به روز رسانی حساب ها
        </v-chip>
        <v-spacer/>
        <v-btn light icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-row class="mx-1">
        <v-col
            cols="12"
            md="3">
          <v-autocomplete
              :items="buildingList"
              v-model="buildingId"
              dense
              outlined
              auto-select-first append-icon="fas fa-angle-down"
              label="انتخاب مجتمع"

          />

        </v-col>

        <v-col
            cols="12"

            md="3">
          <date-picker placeholder="از تاریخ" v-model="from" color="#3b5694" clearable
                       auto-submit>
          </date-picker>
        </v-col>

        <v-col
            cols="12"
            md="3" >
          <date-picker placeholder="تا تاریخ" v-model="to" color="#3b5694" clearable
                       auto-submit>
          </date-picker>
         </v-col>
        <v-col
            cols="12"
            md="3"  class="d-inline-flex">
          <v-autocomplete
              :items="statusList"
              v-model="st"
              dense
              outlined
              auto-select-first append-icon="fas fa-angle-down"
              label="انتخاب وضعیت"

          />
          <v-btn small fab color="primary" @click="search">
            <v-icon>mdi-cloud-search</v-icon>
          </v-btn>
        </v-col>


      </v-row>
      <v-col cols="12"
             sm="12" md="12" class="d-inline-block">
        <b-pagination
            v-model="skip"
            :total-rows="paging.totalSize"
            :per-page=take
            first-text="اولین"
            prev-text="<"
            next-text=">"
            last-text="آخرین"
            dir="ltr"
            limit="5"
            @change="pageChangeHandler"
        />
      </v-col>
      <v-card-text>
          <b-table
              :items="dataItems"
              :fields="columns"
              :current-page="skip"
              :per-page=0
              stacked="md"
              show-empty
              responsive
              striped
              style="font-size: 13px;color: black ;width: 100%;">
<!--            <template #cell(status)="row">-->
<!--              <span v-if="row.item.status===false">به روز نشده</span>-->
<!--              <span v-else>به روزشده</span>-->
<!--            </template>-->

           <template #cell(actions)="row">
             <v-btn small depressed @click="updateAccount(row.item.id)" color="primary"> بروزرسانی</v-btn>
            </template>

          </b-table>

      </v-card-text>
    </v-card>
  </div>
</template>

<script>

import Account_se from "./Account_se";
import {mapMutations} from "vuex";

export default {
  name: 'account',
  components: {

  },
  data() {
    return {

      searchvalue: '',
      modelId: '',
      model: {},
      dataItems: [],
      buildingId: '',
      st: '',
      from: '',
      to: '',
      buildingList: [],
      statusList: [{text:'به روز شده',value:"1"},{text:'به روز نشده',value:"0"},],
      bindingErrors: [],
      paging: {},
      skip: 1,
      take: 10,
      currentPage: 1,
      columns: [
        {key: 'buildingName', label: 'مجتمع',  },

        {key: 'caption', label: 'توضیحات', },
        {key: 'lastUpdateText', label: 'تاریخ بروز رسانی', },
        {key: 'actions', label: 'عملیات'}
      ],

    };

  },

  methods: {
    close() {
      this.$router.push('/account')
    },
    ...mapMutations({
      setDrawer: 'SET_DRAWER',
      setMini: 'SET_MINI',
    }),



    updateAccount(id) {
      this.$progress({message: 'درحال به روزرسانی حساب ها...'}, true)
      Account_se. updateAccount_BuildingUpdate(id).then(response => {
        if (response && response.status === 200) {
          this.$root.$emit('Progress')
          this.getPage()
          this.$snack({type: 'success'})
        } else if (response && response.status === 408) {
          this.$root.$emit('Progress')

        } else if (response && response.response.status === 400) {
          this.$root.$emit('Progress')
          this.loading = false
          this.bindingErrors = response.response.data;
        }
      })

    },



    pageChangeHandler: function (event) {
      this.skip = event;
      this.getPage();

    },

    search() {
      this.skip = 1
      this.take = 10
      Account_se.searchBuildingUpdate(this.st, this.buildingId, this.from,this.to,this.skip - 1, this.take).then(response => {
        this.paging = response.data.page
        this.dataItems = response.data.list
      });
    },
   getPage() {
      Account_se.listBuildingUpdate().then(response => {
        this.buildingList = response.data.buildingItems
        this.from=response.data.from
        this.to=response.data.to
      });
    },


  },

  created() {
    this.setDrawer(false)
    this.getPage()
  }

}
</script>

<style>
.table th, .table td {
  padding: 5px !important;
}

</style>
<style scoped>
::v-deep th {
  white-space: nowrap;
}
::v-deep td {
  white-space: nowrap;
}
</style>